import axiosInstance from "../../utils/axiosInstance";

const eventService = {

    getList: async (page = 1, pageSize = 10, search = "") => {

        const response = await axiosInstance.get("/Event", {
            params: {
                page,
                pageSize,
                search
            }
        });

        return response.data;
    },

    getById: async (id) => {

        const response = await axiosInstance.get(`/Event/${id}`);

        return response.data;
    },

    create: async (data) => {

        const response = await axiosInstance.post(
            "/Event",
            data
        );

        return response.data;
    },

    update: async (id, data) => {

        const response = await axiosInstance.put(
            `/Event/${id}`,
            data
        );

        return response.data;
    },

    delete: async (id) => {

        const response = await axiosInstance.delete(
            `/Event/${id}`
        );

        return response.data;
    }

};

export default eventService;